// extracted by mini-css-extract-plugin
export default {"link-arrow":"link-arrow--c-eJ3","linkArrow":"link-arrow--c-eJ3","blurb":"blurb--EHRvZ"};